import React from 'react';
import './Hero.css';
import heroImg from '../../assets/images-sites/img-accueil.jpg';

const Hero = () => {
    return (
        <section className="hero-section">
            {/* Background Image from assets */}
            <div className="hero-background-image" style={{ backgroundImage: `url(${heroImg})` }}></div>
            
            <div className="container hero-content-container py-5">
                <div className="row h-100 align-items-center">
                    {/* Left Side Content */}
                    <div className="col-lg-7 hero-left-side animate__animated animate__fadeInLeft">
                        {/* Logo removed as it's now in the Navbar */}
                        <div className="hero-text-block">
                            <h1 className="hero-main-title static-text text-white mb-3">
                                À chaque pas, la lumière de la Parole de Dieu.
                            </h1>
                            <h2 className="hero-sub-title text-white opacity-90 fw-light mb-5 fs-4">
                                Pour l'édification du corps de Christ.
                            </h2>
                            <p className="hero-description mb-5 text-white lead opacity-75">
                                Nous sommes une structure d'édification et d'évangélisation basée sur la Bible comme la Parole inspirée de Dieu et le guide suprême pour agir, décider et faire de choix suivant le plan de Dieu.
                            </p>
                            <div className="d-flex gap-3">
                                <button className="btn-hero-golden shadow-lg">
                                    En savoir plus
                                </button>
                                <button className="btn-hero-outline shadow-lg">
                                    Nous suivre
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* Right Side Empty */}
                    <div className="col-lg-5 d-none d-lg-block"></div>
                </div>
            </div>

            {/* Glowing Footprints Overlay */}
            <div className="footprints-light-layer"></div>
        </section>
    );
};

export default Hero;
